export * from './toolbar.component';
export * from './toolbar-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/toolbar/index.ts